import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function ArticleListPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: '文章资讯' },
              ]}
            />
          </div>
        </div>

        <div className="w-full px-4 md:px-6 py-8">
          <div className="max-w-5xl mx-auto">
            <div className="mb-10">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                文章资讯
              </h1>
              <p className="text-sm text-foreground-600">
                软件教程、行业资讯、使用技巧，掌握最新科技动态
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {articles.map((article) => {
                const cat = categories.find((c) => c.slug === article.category);
                return (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="group flex flex-col sm:flex-row bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
                  >
                    <div className="sm:w-48 flex-shrink-0 aspect-[16/9] sm:aspect-auto overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="flex-1 p-5 flex flex-col justify-between">
                      <div>
                        <div className="flex items-center gap-2 mb-2 flex-wrap">
                          {cat && (
                            <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                              {cat.name}
                            </span>
                          )}
                          {article.tags.slice(0, 2).map((tag) => (
                            <span key={tag} className="text-[10px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                              {tag}
                            </span>
                          ))}
                        </div>
                        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                          {article.title}
                        </h3>
                        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                          {article.excerpt}
                        </p>
                      </div>
                      <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
                        <span>{article.publishDate}</span>
                        <span>{article.readTime} · {article.views.toLocaleString()} 阅读</span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}